import { motion } from 'framer-motion';
import { PageHero, SectionHeader } from '@/components/common/Sections';
import { CTABanner } from '@/components/common/Cards';
import { PARTNERS, IMAGES } from '@/lib/constants';

export default function PartnersPage() {
  const partnerCategories = [
    { title: "Airlines", partners: PARTNERS.airlines },
    { title: "Embassies & Consulates", partners: PARTNERS.embassies },
    { title: "Tourism Boards", partners: PARTNERS.tourismBoards },
    { title: "Industry Associations", partners: PARTNERS.associations },
  ];

  return (
    <div className="page-transition">
      <PageHero title="Partners & Affiliations" subtitle="Trusted partnerships that power our excellence" backgroundImage={IMAGES.corporateTravel} />

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="inline-block bg-[#0A1F3D] text-white px-8 py-4 mb-8">
              <span className="text-[#D4AF37] font-bold">DUAL IATA ACCREDITED</span>
            </motion.div>
            <h2 className="text-3xl md:text-4xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-6">A Rare Mark of Trust</h2>
            <p className="text-[#4A5568] text-lg leading-relaxed">Osaka Group is one of the few travel agencies in Kerala to hold dual IATA accreditation.</p>
          </div>
        </div>
      </section>

      {partnerCategories.map((category, catIndex) => (
        <section key={catIndex} data-testid={`partner-section-${catIndex}`} className={`section-padding ${catIndex % 2 === 0 ? 'bg-[#F5F5F5]' : 'bg-white'}`}>
          <div className="container-custom">
            <SectionHeader overline="Our Partners" title={category.title} />
            <div className="flex flex-wrap justify-center gap-8">
              {category.partners.map((partner, index) => (
                <motion.div key={index} initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: index * 0.05 }} className="px-8 py-4 bg-white border border-slate-200 partner-logo hover:border-[#D4AF37]">
                  <span className="font-semibold text-[#0A1F3D]">{partner}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      ))}

      <CTABanner />
    </div>
  );
}
